import styled from 'styled-components'
import { SLIP_IN_PROGRESS_STATUS, SLIP_STATUS } from '../../constants'
import { FormControl } from '../../styles'
import { useState } from 'react'

const ActionBox = ({ slip, onClickApprove, onClickReject, onClickRecheck }) => {
  const [refNumber, setRefNumber] = useState('')
  const [amount, setAmount] = useState('')
  const [confirmAmount, setConfirmAmount] = useState('')

  const isAmountsMatched = amount === confirmAmount

  const handleOnChange = (event) => {
    switch (event.target.name) {
      case 'refNumber':
        if (/^[0-9a-z]+$/i.test(event.target.value) || event.target.value === '') {
          setRefNumber(event.target.value)
        }
        break
      case 'amount':
        if (/^[0-9]+(\.{1}[0-9]{0,2})?$/.test(event.target.value) || event.target.value === '') {
          setAmount(event.target.value)
        }
        break

      case 'confirmAmount':
        if (/^[0-9]+(\.{1}[0-9]{0,2})?$/.test(event.target.value) || event.target.value === '') {
          setConfirmAmount(event.target.value)
        }
        break
      default:
        break
    }
  }

  if (slip.inProgress === SLIP_IN_PROGRESS_STATUS.BAD_SLIP || slip.inProgress === SLIP_IN_PROGRESS_STATUS.OUT_QUEUE) {
    return (
      <Container>
        <FormControl name="refNumber" value={refNumber} onChange={handleOnChange} placeholder="เลขที่อ้างอิง" />
        <FormControl name="amount" value={amount} onChange={handleOnChange} placeholder="จำนวนเงิน" />
        <FormControl
          name="confirmAmount"
          value={confirmAmount}
          onChange={handleOnChange}
          placeholder="ยืนยันจำนวนเงิน"
        />
        {!isAmountsMatched && <div style={{ color: 'red' }}>จำนวนเงินที่กรอกไม่ตรงกัน</div>}
        <ActionButtons
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
          }}
        >
          <button
            className="btn btn-success"
            disabled={!isAmountsMatched}
            onClick={() => onClickApprove(slip.id, refNumber, amount)}
          >
            Approve
          </button>
          <button className="btn btn-danger" onClick={() => onClickReject(slip.id)}>
            Reject
          </button>
          <button className="btn btn-primary" onClick={() => onClickRecheck(slip.imageURL, slip.id, slip.qrText)}>
            Recheck
          </button>
        </ActionButtons>
      </Container>
    )
  }

  return (
    slip.status === SLIP_STATUS.REJECT && (
      <ActionButtons
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
        }}
      >
        <button className="btn btn-primary" onClick={() => onClickRecheck(slip.imageURL, slip.id, slip.qrText)}>
          Recheck
        </button>
      </ActionButtons>
    )
  )
}

export default ActionBox

const Container = styled.div`
  padding-top: 8px;
  display: grid;
  gap: 8px;
`

const ActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`
